import React from 'react';
import PropTypes from 'prop-types';
import gtm from 'general/js/gtm';

const AlertBar = ({ model }) => {
    const onClickLink = () => {
        gtm.push('Alert bar', 'Read More', model.title);
    };

    return (
        <div className="alert-bar">
            <div className="container">
                <div className="alert-bar__copy">
                    <strong>{model.title}</strong>
                    <span>&nbsp;{model.subtitle}</span>
                    {
                        model.linkUrl &&
                        <a
                            className="alert-bar__link"
                            href={model.linkUrl}
                            onClick={onClickLink}>
                            {model.linkText}
                        </a>
                    }
                </div>
            </div>
        </div>
    );
};

AlertBar.propTypes = {
    model: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        linkUrl: PropTypes.string,
        linkText: PropTypes.string,
    })
};

export default AlertBar;
